module.exports = __webpack_public_path__ + "img/d.1f649200.jpg";